import React from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import NavBar from './NavBar'

export default function SharedLayouts() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <div className="app-layout">
      {!isHomePage && <NavBar />}
      <main className="main-content">
        <Outlet/>
      </main>
    </div>
  )
}
